import { render } from "./Developers.vue?vue&type=template&id=2ebbb40e&scoped=true"
import script from "./Developers.vue?vue&type=script&lang=js"
export * from "./Developers.vue?vue&type=script&lang=js"

import "./Developers.vue?vue&type=style&index=0&id=2ebbb40e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebbb40e"]])

export default __exports__